const menu = [
  {
    text: 'Overview',
    link: '/',
  },
  {
    text: 'Operations',
    subMenu: [
      { text: 'Bot status', link: '/bots-dashboard' },
      { text: 'Network map', link: '/heartbeat-network' },
    ],
  },
  {
    text: "Risk",
    link: "/circuit-breakers"
  },
  {
    text: "Signals",
    link: "/signals-dashboard"
  },
  {
    text: 'Instruments',
    subMenu: [
      {
        text: 'Digital Assets',
        link: '/instruments-crypto-exchanges',
      }
    ],
  },
  {
    text: 'Performance',
    subMenu: [
      {
        text: 'Accounts & P&L',
        link: '/daily-pnl',
      },
      {
        text: "Trade statistics",
        link: "/trade-stats"
      },
      {
        text: "Execution spreads",
        link: "/spread-summary"
      },
    ],
  },
  {
    text: "Market Data",
    link: "/market-data"
  },
  {
    text: "Swagger API",
    link: "/docs/"
  }
];
export default menu;
